import { Component, createRef } from 'react';
import { NumericFormat } from 'react-number-format';

/**
 * Integer input component
 * @deprecated Use the Trellis Input.Number component instead: https://main--6710219e5989b079dbcc9421.chromatic.com/?path=/docs/components-input-number--docs
 */
class IntegerInput extends Component {
	input = createRef();

	handleChange = e => {
		if (this.props.onChange) {
			this.props.onChange(e);
		}
	};

	getInputRef = element => {
		if (element) {
			if (this.props.disable == true) {
				element.readOnly = true;
			}
		}
	};

	render() {
		const { id, className, required, value, name, allowNegative = false, thousandSeparator = ',', ...rest } = this.props;

		if (rest.onChange) {
			delete rest.onChange;
		}

		const attrs = {
			...rest,
			id,
			className,
			value,
			name,
			required,
			decimalScale: 0,
			allowNegative,
			thousandSeparator,
			fixedDecimalScale: true
		};

		return <NumericFormat {...attrs} autoComplete="off" getInputRef={this.getInputRef} onValueChange={this.handleChange} />;
	}
}

export default IntegerInput;
